import { replaceOriginKeys } from '../../functions/primitiveHelpers/urlHelpers';

export const SITE_NAV_BREAK_POINT = 1024;

export const SITE_NAV_MODE = {
  None: 0,
  HamburgerMenu: 1,
  HamburgerMenuSearch: 2,
  UserMenu: 3,
  Search: 4
};

const SITE_NAV_SECTION_ID = {
  PopularSports_AllSports: 'PopularSports-AllSports',
  PopularSports_Boys: 'PopularSports-Boys',
  PopularSports_Girls: 'PopularSports-Girls',
  Media_Apps: 'Media-Apps',
  Media_Photography: 'Media-Photography',
  Media_Video: 'Media-Video'
};

const parseLinks = links =>
  links.map(link => {
    const { url, ...rest } = link;
    return {
      href: replaceOriginKeys(url),
      ...rest
    };
  });

export const getMainSportLinksData = (siteNavData, includeHeaderLink = true) =>
  siteNavData.sections.slice(0, 5).map(section => {
    const parsedLinks = parseLinks(section.links);

    return {
      id: section.id,
      text: section.header,
      href: includeHeaderLink ? parsedLinks[0].href : undefined,
      subItems: parsedLinks
    };
  });

const getAllSportsData = siteNavData => {
  const section = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.PopularSports_AllSports
  );

  return {
    text: section.header,
    href: replaceOriginKeys(section.links[0].url)
  };
};

export const getMediaData = (siteNavData, flatten = false) => {
  const apps = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.Media_Apps
  );
  const photography = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.Media_Photography
  );
  const video = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.Media_Video
  );

  const appLinks = parseLinks(apps.links);
  const photographyLinks = parseLinks(photography.links);
  const videoLinks = parseLinks(video.links);

  const appData = {
    text: apps.header,
    subItems: appLinks
  };

  const photographyData = flatten
    ? {
        text: photography.header,
        href: photographyLinks[0].href
      }
    : {
        text: photography.header,
        subItems: photographyLinks
      };

  const videoData = flatten
    ? {
        text: video.header,
        href: videoLinks[0].href
      }
    : {
        text: video.header,
        subItems: videoLinks
      };

  return [appData, photographyData, videoData];
};

export const getHamburgerLinksData = siteNavData => {
  const mainLinks = getMainSportLinksData(siteNavData, false);
  const allSportsLink = getAllSportsData(siteNavData);
  const mediaLinks = getMediaData(siteNavData, true);

  return [...mainLinks, allSportsLink, ...mediaLinks];
};

export const getMoreSportsData = siteNavData => {
  const allSports = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.PopularSports_AllSports
  );
  const popularBoys = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.PopularSports_Boys
  );
  const popularGirls = siteNavData.sections.find(
    s => s.id === SITE_NAV_SECTION_ID.PopularSports_Girls
  );

  const boysLinks = parseLinks(popularBoys.links);
  const girlsLinks = parseLinks(popularGirls.links);

  return {
    id: 'more',
    text: '...',
    href: replaceOriginKeys(allSports.links[0].url),
    leftItems: boysLinks,
    rightItems: girlsLinks
  };
};
